// extracted by mini-css-extract-plugin
module.exports = {"root":"Q_x6_"};